import { gql } from "@apollo/client"

const CREATE_JITSI_CONFERENCE_SUMMARY_MUTATION = gql`
  mutation($input: CreateJitsiConferenceSummaryInput!) {
    createJitsiConferenceSummary(input: $input) {
      id
      room_id
      event_id
      user_id
      booking_slot_id
      ip_address
      agent_details
      join_button_clicked_at
      joined_at
      left_at
    }
  }
`

export { CREATE_JITSI_CONFERENCE_SUMMARY_MUTATION }